import script from "./WalletLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__